import { setLogout } from '../state';
import ieqipCoreServiceApi from '../apis/ieqipCoreServiceApi';
import securityApi from '../apis/securityApi';
import firmApi from '../apis/firmApi';
import assignmentApi from '../apis/assignmentApi';
import inspectionApi from '../apis/inspectionApi';
import documentApi from '../apis/documentApi';
import noteApi from '../apis/noteApi';
import lookupApi from '../apis/lookupApi';
import codeTablePostgresApi from '../apis/codeTablePostgresApi';
import tenantApi from '../apis/tenantApi';
import accessManagementApi from '../apis/accessManagementApi';

const setupApiInterceptors = (dispatch) => {
  const apis = [
    ieqipCoreServiceApi,
    securityApi,
    firmApi,
    assignmentApi,
    inspectionApi,
    documentApi,
    noteApi,
    lookupApi,
    codeTablePostgresApi,
    tenantApi,
    accessManagementApi
  ];

  apis.forEach(api => {
    api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {

        // Check for network errors and authorization issues
        const isNetworkError = error.code === 'ERR_NETWORK' || error.message === 'Network Error';
        const hasAuthHeader = error.config?.headers?.Authorization;
        const isAuthError = error.response?.status === 401 || 
                          error.response?.data?.status === 401 ||
                          error.message?.includes('401') ||
                          error.message?.includes('unauthorized') ||
                          error.message?.includes('Unauthorized');

        // If it's a network error and we have an auth header, treat it as an auth issue
        if ((isNetworkError && hasAuthHeader) || isAuthError) {
          console.log("Authentication error detected - Logging out user");
          // Only dispatch logout and redirect if not already on login page
          if (!window.location.pathname.includes('/login')) {
            dispatch(setLogout());
            window.location.replace('/login');
          }
          return Promise.reject(error);
        }
        
        // Handle 404 Not Found - allow to continue
        if (error.response?.status === 404) {
          console.log('404 Not Found - Continuing with request');
          return Promise.reject(error);
        }

        // Handle network errors without auth header
        if (isNetworkError) {
          console.log('Network error - No response received:', error.request);
          return Promise.reject(error);
        }

        // Handle CORS errors
        if (error.message?.includes('Network Error') || error.message?.includes('CORS')) {
          console.log('Network/CORS error:', error.message);
          return Promise.reject(error);
        }

        // Handle all other errors (including 500)
        console.log('API error:', error.message);
        return Promise.reject(error);
      }
    );
  });
};

export default setupApiInterceptors; 